import React from "react";

function YearSelector({ years, selected, onChange }) {
  return (
    <div className="year-selector">
      {years.map((y) => (
        <button
          key={y}
          type="button"
          className={
            "year-selector__pill" +
            (y === selected ? " year-selector__pill--active" : "")
          }
          onClick={() => onChange(y)}
        >
          {y}
        </button>
      ))}
    </div>
  );
}

export default YearSelector;
